// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2zhsH","signatureBlock":"Footer_signatureBlock__1gx6B","signature":"Footer_signature__1e5fx"};